/**
 * SEARCH-002 — Compositeur d'email lancé depuis l'aperçu de la palette ⌘K.
 *
 * Compositeur GÉNÉRIQUE « classique » (champs À / Cc / Cci saisie libre + annuaire,
 * modèle + pièces jointes) modelé sur l'envoi d'ADB, mais sans document. Le À est
 * pré-rempli avec l'email du contact / apprenant / collègue trouvé. Envoi via
 * `POST /api/emails/compose` (tracé dans l'historique d'emails général).
 *
 * Chargé en LAZY : ce compositeur est lourd et ne doit pas alourdir le bundle du header
 * (où vit la palette) ; il n'est importé qu'à la première ouverture.
 */

import { lazy, Suspense } from 'react'

const SearchEmailComposerDialog = lazy(() =>
    import('./SearchEmailComposerDialog').then((m) => ({
        default: m.SearchEmailComposerDialog,
    })),
)

export function SearchEmailComposer({
    open,
    recipientEmail,
    entityId,
    onOpenChange,
}: {
    open: boolean
    recipientEmail: string
    entityId: string
    onOpenChange: (open: boolean) => void
}) {
    // Monté uniquement quand on compose (miroir de `SearchDocumentQuickLook`) → aucun
    // coût tant que l'utilisateur ne clique pas « Envoyer un email ».
    if (!open || !recipientEmail) return null
    return (
        <Suspense fallback={null}>
            <SearchEmailComposerDialog
                open
                onOpenChange={onOpenChange}
                entityId={entityId}
                recipientEmail={recipientEmail}
            />
        </Suspense>
    )
}
